export default __webpack_public_path__ + "static/relationship-mr-41992a05b1c8e63e749bed35e6dab596.gif";